module.exports = __webpack_public_path__ + "img/menu.2525d1f5.svg";